<template>
  <div class="children-Root">
    <div class="top" style="position: relative;">
      <div>
        <div style="display: flex;">
          <img @click="$parent.isSetIsChildren(false)" style="height: 20px;position: relative;top: 5px;margin-right: 10px;cursor: pointer;" src="../../../assets/custom-image/back.png" alt="">
          <h3>{{ itemData.productName }}</h3>
        </div>
        <!-- {{itemData}} -->
        <div style="margin-top: 10px;">{{`pid: ${itemData.pId} 产品名称: ${itemData.productName} 自定义名称: ${itemData.customName} 设备型号: ${itemData.productModel}`}}</div>
        <el-button @click="pushDev" style="height: 35px;position: absolute;right: 0;top: 0;" :size="this.$store.state.btnSize" type="primary">{{ itemData.state == 0?'发布':'下架' }}产品</el-button>
      </div>
      <div v-show="false">
        <h3>标准功能、自定义功能(可选)、高级功能(可选)、共同定义产品功能，设备控制面板和固件都与产品功能有关</h3>
      <div>
      </div>
      </div>
    </div>

    <div v-show="false" style="width: 100%;padding: 10px;height:72px;box-sizing: border-box;padding-right: 0px;display: flex;justify-content: space-between;background-color: #F7F9FA;margin-top: 20px;">
      <div class="title">
        <div class="box" v-for="(item,index) in titleData" :key="index">
          <div class="box-title">{{ item.label }}</div>
          <div class="box-number">{{ item.number }}</div>
        </div>
      </div>
    </div>
    <TableBlock v-if="false" ref="tableData" :columns="columns" :action="action" :param="param" :navHeight="320">
      <div class="common-space-between">
          <div class="common-space-around">
              <el-input v-model="param.name" :size="this.$store.state.inputSize" placeholder="请输入套餐名称"  style="margin-right:10px;width:200px"/>
              <el-button type="primary" icon="el-icon-search" :size="this.$store.state.btnSize"  @click="searchBtn">搜索</el-button>
              <el-button type="danger"  icon="el-icon-refresh" :size="this.$store.state.btnSize"  @click="resetBtn">重置</el-button>
          </div>
          <el-button type="primary" icon="el-icon-plus" size="small" @click="addBtn">添加功能</el-button>
      </div>
    </TableBlock>

    <TableBlock ref="tableData2" :ispage="false" tablePadding="15px 15px 15px 0px" :columns="columns2" :action="action2" :param="param2" :navHeight="290" :topWidth="11" :topHegiht="489">
      <div class="common-space-between">
          <div class="common-space-around">
              <el-input v-model="param.name" :size="this.$store.state.inputSize" placeholder="请输入产品id"  style="margin-right:10px;width:200px"/>
              <el-button type="primary" icon="el-icon-search" :size="this.$store.state.btnSize"  @click="searchBtn2">搜索</el-button>
              <el-button type="danger" icon="el-icon-refresh" :size="this.$store.state.btnSize"  @click="resetBtn2">重置</el-button>
          </div>
          <el-button type="primary" icon="el-icon-plus" size="small" @click="openDivBtn">添加自定义功能</el-button>
      </div>
    </TableBlock>
    <functionality ref="functionality"></functionality>
    <divFunction ref="divFunction"></divFunction>
  </div>
</template>
<script>
import functionality from './module/functionality.vue'
import divFunction from './module/div-function.vue'
import TableBlock from "./module-table/block-table.vue";
import {columns} from './columns';
import {columns as devCol} from './div-columns'
import {operate} from '@/utils/config'
import { getFun } from '@/utils/httpFun'
import { iotApi } from '../../../utils/config';
import { postFun } from '../../../utils/httpFun';
export default {
  name: 'index',
  props:{
    itemData:{
      type:Object,
      default:null
    }
  },
  components:{
      TableBlock:TableBlock,
      divFunction:divFunction,
      functionality:functionality
  },
  data:()=>({  
    action:operate.SYSTEMTAOCANDXVOILIST,
    columns:[],    //表头
    param:{        //请求参数
       type:1,     //1短信 2语音
       name:null     
    },
    action2:iotApi.SELECTPRODUCTATTR,
    columns2:[],
    param2:{
      pId:null
    },
    titleData:[
      {
        label:'标准功能(个)',
        number:'0'
      },
      {
        label:'高级功能(个)',
        number:'0'
      }
    ]
  }),
  created(){
     this.columns = columns(this);
     this.columns2 = devCol(this);
     this.param2.pId = this.$parent.getPid();
  },
  methods:{
     pushDev(){
      this.$confirm(`是否${this.itemData.state == 0?'发布':'下架'}产品?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(this.itemData)
        // 发布
        getFun(iotApi.PUBLISHPRODUCT,{
            id:this.itemData.id,
            state:this.itemData.state == 0?1:0
          },res=>{
            if(res.data){
              this.$message({
                type: 'success',
                message: `${this.itemData.state == 0?'发布':'下架'}成功`
              });
              this.itemData.state = this.itemData.state == 0?1:0;
              this.getData();
            }else{
              this.$message({
                type: 'error',
                message: `${this.itemData.state == 0?'发布':'下架'}失败`
              });
            }
          })
      })
     },
     getPid(){
      console.log('=============')
      return this.itemData.pId;
     },
      //查询
      searchBtn2(ev){
           this.$nextTick(res=>{
              this.$refs.tableData2.getDatas() 
           })
     },
     resetBtn2(){
        this.$nextTick(res=>{
           this.$refs.tableData2.resetHttp() 
        })
     },
     //查询
     searchBtn(ev){
           this.param.type = ev
           this.$nextTick(res=>{
              this.$refs.tableData2.getDatas() 
           })
     },
     //重置第一页
     resetBtn(){
        this.param.name = null
        this.$nextTick(res=>{
           this.$refs.tableData.resetHttp() 
        })
     },
     //新增
     addBtn(){
        this.$refs.functionality.open('add');
     },
     showOperateBtn(index,item){
      if(index == 0){
        this.$refs.divFunction.open('edit',item,()=>{
         this.searchBtn();
        });
      }
     },
     openDivBtn(){
      console.log('=================',this.$refs.divFunction)
      this.$refs.divFunction.open('add',undefined,()=>{
        this.searchBtn();
      });
     }
  }
}
</script>
<style lang="scss" scoped>
  ::v-deep .el-button{
    border-radius: 6px;
  }
  .top{
      div:nth-child(1){
        div:nth-child(2){
          color: #949AA6;
          font-size: 14px;
        }
      }
      div:nth-child(2){
        h3{
          margin-top: 30px;
          margin-bottom: 8px;
        }
      }
    }
    .title{
      border-radius: 10px;
      width: 255px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      padding-left: 12px;
      padding-right: 30px;
      position: relative;
      &::before{
        content: "";
        display: block;
        height: 50%;
        width: 1px;
        left: 47%;
        background-color: rgba(0,0,0,0.2);
        position: absolute;
      }
      &::after{
        content: "";
        display: block;
        height: 50%;
        width: 1px;
        left: 100%;
        background-color: rgba(0,0,0,0.2);
        position: absolute;
      }
    }
    .box{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 15px;
      .box-title{}
      .box-number{
        width: 100%;
        font-weight: bold;
        font-size: 20px;
        text-align: left;
      }
     
    }
    .children-Root{
      box-sizing: border-box;
      height: 100%;
      width: 100%;
      overflow: scroll;
      overflow-x: hidden;
      position: relative;
      padding: 20px;
    }
     ::v-deep .el-button--mini{
       padding: 5px 8px;
       
     }
</style>
